module.exports = __webpack_public_path__ + "img/Merlin.c5b54f52.png";